import React, { useState, useEffect, useRef } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';
import { toast } from 'react-toastify';

const ESTADOS = {
  NOT_CREATED:  { label: 'Extensión no conectada', color: '#6b7280', icon: '⚪' },
  INITIALIZING: { label: 'Extensión conectada, esperando WhatsApp Web...', color: '#f59e0b', icon: '🟡' },
  READY:        { label: 'Conectado', color: '#10b981', icon: '🟢' },
};

const WhatsApp = () => {
  const [estado, setEstado] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generando, setGenerando] = useState(false);
  const [token, setToken] = useState('');
  const pollingRef = useRef(null);

  const fetchEstado = async () => {
    try {
      const { data } = await api.get('/whatsapp/estado');
      setEstado({ ...data, status: data.status?.toUpperCase() });
    } catch {
      setEstado({ status: 'NOT_CREATED' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEstado();
    pollingRef.current = setInterval(fetchEstado, 4000);
    return () => clearInterval(pollingRef.current);
  }, []);

  const handleGenerarToken = async () => {
    setGenerando(true);
    try {
      const { data } = await api.post('/whatsapp/generar-token');
      setToken(data.token);
      toast.success('Token generado — pégalo en la extensión');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al generar el token');
    } finally {
      setGenerando(false);
    }
  };

  const copiarToken = () => {
    navigator.clipboard.writeText(token);
    toast.success('Token copiado');
  };

  const info = ESTADOS[estado?.status] || ESTADOS.NOT_CREATED;
  const conectado = estado?.status === 'READY';

  return (
    <Layout>
      <div style={{ maxWidth: 600, margin: '2rem auto', padding: '0 1rem' }}>
        <h2 style={{ marginBottom: '0.25rem' }}>📱 WhatsApp</h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '2rem', fontSize: '0.9rem' }}>
          Conecta la extensión de WhatsApp Web para enviar notificaciones automáticas a tus clientes.
        </p>

        {/* Estado */}
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <span style={{ fontSize: '1.5rem' }}>{info.icon}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: '1rem' }}>Estado de conexión</div>
              <div style={{ color: info.color, fontWeight: 500 }}>{loading ? 'Cargando...' : info.label}</div>
            </div>
          </div>
        </div>

        {/* Instrucciones + token */}
        {!conectado && (
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div style={{ fontWeight: 600, marginBottom: '0.75rem' }}>Cómo conectar</div>
            <ol style={{ paddingLeft: '1.2rem', fontSize: '0.9rem', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              <li>Instala la extensión "FactuTracks - Conector WhatsApp" en Chrome o Brave.</li>
              <li>Genera un token abajo y pégalo en la configuración de la extensión.</li>
              <li>Abre <strong>web.whatsapp.com</strong> y escanea el QR con tu celular si no lo has hecho.</li>
              <li>Deja esa pestaña abierta — mientras esté abierta, WhatsApp funcionará en el CRM.</li>
            </ol>

            <button className="btn btn-primary" onClick={handleGenerarToken} disabled={generando} style={{ marginTop: '0.5rem' }}>
              {generando ? 'Generando...' : token ? '🔄 Regenerar token' : '🔑 Generar token'}
            </button>

            {token && (
              <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
                <input
                  readOnly
                  value={token}
                  style={{ flex: 1, fontFamily: 'monospace', fontSize: '0.8rem', padding: '0.5rem', border: '1px solid var(--border)', borderRadius: '6px' }}
                  onFocus={(e) => e.target.select()}
                />
                <button className="btn btn-secondary" onClick={copiarToken}>📋 Copiar</button>
              </div>
            )}
          </div>
        )}

        {/* Notificaciones activas */}
        {conectado && (
          <div className="card" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
            <div style={{ fontWeight: 600, marginBottom: '0.75rem', color: '#065f46' }}>✅ Notificaciones activas</div>
            <ul style={{ margin: 0, paddingLeft: '1.2rem', color: '#047857', fontSize: '0.9rem', lineHeight: 1.8 }}>
              <li>Confirmación al crear una cita</li>
              <li>Aviso al cancelar una cita</li>
              <li>Recordatorio 24 horas antes</li>
              <li>Confirmación de anticipo pagado</li>
              <li>Aviso a lista de espera cuando se libera un cupo</li>
            </ul>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default WhatsApp;
